export default __webpack_public_path__ + "static/media/talents.1c9870c5.jpg";